"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _provider = _interopRequireDefault(require("../../provider"));
var _XumoNativeService = _interopRequireDefault(require("./XumoNativeService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class XumoMetricsProvider extends _provider.default {
  /** @override */
  collectAll() {
    return _XumoNativeService.default.collectAll();
  }
  getConnectionType() {
    return _XumoNativeService.default.getConnectionType();
  }
  getNetworkMetrics() {
    return _XumoNativeService.default.getNetworkMetrics();
  }
  getSystemMetrics() {
    return _XumoNativeService.default.getSystemMetrics();
  }
  getDeviceName() {
    return _XumoNativeService.default.getDeviceName();
  }
  getDeviceId() {
    return _XumoNativeService.default.getDeviceId();
  }
}
var _default = exports.default = XumoMetricsProvider;